module.exports = __webpack_public_path__ + "media/dog-personality-traits/stick-d496fb43.svg";